import { useEffect } from "react";

/**
 * Stripe 3DS2 appends the challenge iframe to document.body. Cascadia's
 * React Aria Modal sets `inert` on siblings (`shouldUseInert: true`) and
 * FocusScope pulls keyboard focus back into Add payment profile / Pay
 * invoice when that iframe is focused.
 *
 * Strip `inert` so clicks reach the challenge. Mark
 * `data-react-aria-top-layer` so FocusScope treats it as in-scope (Adobe's
 * escape hatch for third-party overlays). Complete/Fail can work after
 * stripping `inert` alone; Amex SafeKey still needs top-layer so the
 * verification-code field can keep focus. FR-1292.
 */
const REACT_ARIA_TOP_LAYER = "data-react-aria-top-layer";

function unlockNode(node: HTMLElement): void {
  node.setAttribute(REACT_ARIA_TOP_LAYER, "true");
  node.removeAttribute("inert");
  node.removeAttribute("aria-hidden");
}

export function unlockStripe3dsOverlays(): void {
  document.querySelectorAll('iframe[src*="stripe"]').forEach((iframe) => {
    if (iframe.closest(".react-aria-ModalOverlay")) {
      return;
    }
    for (
      let node: HTMLElement | null = iframe as HTMLElement;
      node && node !== document.body;
      node = node.parentElement
    ) {
      unlockNode(node);
    }
  });
}

export function useAllowStripe3dsOverlay(): void {
  useEffect(() => {
    if (!document.body) {
      return;
    }
    const run = () => unlockStripe3dsOverlays();
    run();
    const observer = new MutationObserver(run);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["inert", "aria-hidden", "src"],
    });
    return () => observer.disconnect();
  }, []);
}
